import ApiService from "@/api.service";
import API from "@/API";



export const GET_LIST_ORDER = "GET_LIST_ORDER";

export const GET_DETAIL_ORDER = "GET_DETAIL_ORDER";
export const DELETE_ORDER = "DELETE_ORDER";
export const SET_LIST_ORDER = "SET_LIST_ORDER";
export const SET_DETAIL_ORDER = "SET_DETAIL_ORDER";
export const GET_LIST_ORDER_BY_SEARCH = "GET_LIST_ORDER_BY_SEARCH";
export const SET_LIST_ORDER_BY_SEARCH = "SET_LIST_ORDER_BY_SEARCH";
export const UPLOAD_IMAGE_DESIGN = "UPLOAD_IMAGE_DESIGN";
export const UPLOAD_ORDER = "UPLOAD_ORDER";

const state = {
    orders: [],
    orderDetail: {},
    ordersBySearch:[]
};

const getters = {
    orders(state) {
        return state.orders;
    },
    orderDetail(state) {
        return state.orderDetail;
    },

    ordersBySearch(state) {
        return state.ordersBySearch;
    },

};

const actions = {
    [GET_LIST_ORDER](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_ORDER}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_ORDER, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_ORDER](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_ORDER}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_ORDER, data);
                }
                resolve(data);
            });
        });
    },
    [UPLOAD_IMAGE_DESIGN](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_IMAGE_DESIGN}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [GET_LIST_ORDER_BY_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`${API.GET_LIST_ORDER_BY_SEARCH}`, payload).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_ORDER_BY_SEARCH, data);
                }
                resolve(data);
            });
        });
    },
    [DELETE_ORDER](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_ORDER}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPLOAD_ORDER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPLOAD_ORDER}/${payload.id}?_method=PUT`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_ORDER](state, data) {
        state.orders = data.data;

    },
    [SET_DETAIL_ORDER](state, data) {
        state.orderDetail = data.data;
    },
    [SET_LIST_ORDER_BY_SEARCH](state, data) {
        state.ordersBySearch = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};